const dependencies = {};

const Dependency = {
  register(name, dependency) {
    return dependencies[name] = dependency;
  },
  resolve(name) {
    return dependencies[name];
  },
};

export default Dependency;
